import PageWrapper from "@/components/PageWrapper";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorHandler } from "@/components/error-hanlder/ErrorHandler";
import { logError } from "@/components/error-hanlder/error-handler.lib";
import { Suspense, useMemo } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useTaskCollectionDetailOptions } from "./tasks.api";
import { useLocation, useParams } from "react-router";
import TaskCard from "@/components/common/tasks/TaskCard";
import TaskActionButton from "./task-actions/TestActionButton";
import TaskLoading from "./components/cards/GetDonCardLoading";
import NoData from "@/components/common/NoData";
import { useTranslation } from "react-i18next";

const TaskListPage = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorHandler} onError={logError}>
      <Suspense
        fallback={
          <PageWrapper>
            <div className="container grid gap-[1px] pt-4">
              {Array.from({ length: 7 }).map((_, i) => (
                <TaskLoading key={i} />
              ))}
            </div>
          </PageWrapper>
        }
      >
        <BaseTaskListPage />
      </Suspense>
    </ErrorBoundary>
  );
};

const BaseTaskListPage = () => {
  const { t } = useTranslation();
  const { taskCollectionId } = useParams<{ taskCollectionId: string }>();
  const { pathname } = useLocation();
  const isSocial = pathname.endsWith("/social");

  const { data: taskDetail } = useSuspenseQuery(
    useTaskCollectionDetailOptions(taskCollectionId)
  );

  const filteredTasks = useMemo(
    () =>
      taskDetail.tasks.filter((task) =>
        isSocial ? task.section === "SOCIAL" : task.section !== "SOCIAL"
      ),
    [taskDetail, isSocial]
  );

  return (
    <PageWrapper backPath={`/get-don/${taskCollectionId}`}>
      <div className="container pt-2 pb-6">
        <h2 className="text-base font-bold text-white mb-3">
          {isSocial ? t("social_tab") : t("tasks")}
        </h2>
        {filteredTasks.length === 0 ? (
          <div className="flex-1 flex-center min-h-[60vh]">
            <NoData
              image={<img src="images/common-no-data.png" className="size-24" />}
              title={t("no_data_title")}
              description={t("no_data_subtitle")}
              headerClassName="bg-none p-0 m-0"
            />
          </div>
        ) : (
          filteredTasks.map((task) => (
            <TaskCard
              key={task.id}
              {...task}
              actionComponent={
                <TaskActionButton task={task} collectionId={taskCollectionId} />
              }
            />
          ))
        )}
      </div>
    </PageWrapper>
  );
};

export default TaskListPage;
